// @ts-nocheck
import * as React from "react";

const Menu: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="M4 17.27v-1h16v1H4Zm0-4.77v-1h16v1H4Zm0-4.769v-1h16v1H4Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Menu);
